import { WineDefinitionModel, WineryModel, WineModel, UnitOfMeasureModel, CustomerModel, UserModel, AuctionLotAttributeModel, AuctionLotCodedCommentModel, AuctionLotImageModel } from './';

export class AuctionLotModel {
    Id: number;
    AuctionId: number;
    LotNumber: number;
    WineDefinitionId: number;
    WineryId: number;
    WineId: number;
    UnitOfMeasureId: number;
    Vintage: number;
    EstimatePrice: number;
    ReservePrice: number;
    CurrentBidDateTime: Date;
    CurrentBid: number;
    CurrentBidCustomerId: number;
    NextBid?: number;
    Bids: number;
    Bidders: number;
    Watchers: number;
    VendorId: number;
    Quantity: number;
    Location: string;
    WineLocationId: number;
    IsAudited: boolean;
    IsHighlightLot: boolean;
    AuditFlag: boolean;
    BuyerPremium: number;
    VendorPremium: number;
    ReviewNote: string;
    IsMixedLot: boolean;

    WineDefinition: WineDefinitionModel;
    Winery: WineryModel;
    Wine: WineModel;
    UnitOfMeasure: UnitOfMeasureModel;
    Vendor: CustomerModel;
    AuctionLotAttributes: AuctionLotAttributeModel[];
    AuctionLotCodedComments: AuctionLotCodedCommentModel[];
    AuctionLotImages: AuctionLotImageModel[];

    constructor() {
        this.Location = "";
        this.ReviewNote = "";
        this.AuctionLotAttributes = [];
        this.AuctionLotCodedComments = [];
        this.AuctionLotImages = [];
    }
}